import * as React from 'react';
import {
	EditButton,
	Identifier,
	ImageField,
	Labeled,
	Record,
	RecordMap,
	ReferenceField,
	TextField,
	UrlField
} from 'react-admin';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TranslateField } from '../components/TranslateField';

const useListStyles = makeStyles(theme => ({
	card: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		margin: '1.5rem 0',
		boxShadow: '0px 15px 20px #27313f0c !important',
		backgroundColor: 'white'
	},
	cardTitleContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	cardContent: theme.typography.body1,
	cardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '0.5rem 0',
		fontWeight: 'bold'
	}
}));

interface CoachGuideListProps {
	ids?: Identifier[];
	data?: RecordMap<Record>;
	basePath?: string;
}

export const CoachGuideList = (props: CoachGuideListProps) => {
	const { ids, data, basePath } = props;
	const classes = useListStyles();

	if (!ids || !data || !basePath) {
		return null;
	}

	return (
		<div style={{ margin: '1em', backgroundColor: '#F8F9FC' }} className="list-container">
			{ids.map(id => (
				<Card key={id} className={classes.card}>
					<CardHeader
						title={
							<div className={classes.cardTitleContent}>
                                <span>
                                    {data[id].name}
                                </span>
								<EditButton
									resource="coach-guides"
									basePath={basePath}
									record={data[id]}
								/>
							</div>
						}
					/>
					<CardContent className={classes.cardContent}>
						<Labeled label="#" className={classes.cardContentRow}>
							<TextField record={data[id]} source="id" label="#"/>
						</Labeled>
						<Labeled label="IMAGE" className={classes.cardContentRow}>
							<ImageField record={data[id]} source="imageUrl" label="IMAGE"/>
						</Labeled>
						<Labeled label="TITLE" className={classes.cardContentRow}>
							<TextField record={data[id]} source="title" label="TITLE"/>
						</Labeled>
						<Labeled label="DESCRIPTION" className={classes.cardContentRow}>
							<TextField record={data[id]} source="description" label="DESCRIPTION"/>
						</Labeled>
						<Labeled label="CATEGORY" className={classes.cardContentRow}>
							<ReferenceField record={data[id]} source="categoryId" label="FORUM"
							                reference="coach-guide-categories">
								<TextField source="name"/>
							</ReferenceField>

						</Labeled>
						<Labeled label="YOUTUBE_LINK" className={classes.cardContentRow}>
							<UrlField record={data[id]} source="videoUrl" label="YOUTUBE_LINK"/>
						</Labeled>
						<Labeled label="EXTERNAL_LINK" className={classes.cardContentRow}>
							<UrlField record={data[id]} source="externalUrl" label="EXTERNAL_LINK"/>
						</Labeled>
						<Labeled label="LANGUAGE" className={classes.cardContentRow}>
							<TranslateField record={data[id]} source="language" label="LANGUAGE"/>
						</Labeled>
					</CardContent>
				</Card>
			))}
		</div>
	);
};
